// DO NOT EDIT -- generated from fs/api/segment/user_property.proto

import { CustomFieldBoolOperator, CustomFieldBoolsOperator, CustomFieldDateOperator, CustomFieldDatesOperator, CustomFieldFloatOperator, CustomFieldFloatsOperator, CustomFieldIntOperator, CustomFieldIntsOperator, CustomFieldStringOperator, CustomFieldStringsOperator, DateOperator, DurationOperator, NumericOperator, SignedUpOperator, StringOperator } from './operators.proto';

export interface UserProperty {
  primary: UserFilter | null;
}

export interface UserFilter {
  email?: StringOperator | null;
  name?: StringOperator | null;
  signedUp?: SignedUpOperator | null;
  userId?: StringOperator | null;
  totalActiveTime?: DurationOperator | null;
  totalTime?: DurationOperator | null;
  averageSessionActiveTime?: DurationOperator | null;
  averageSessionLength?: DurationOperator | null;
  firstSeen?: DateOperator | null;
  totalSessions?: NumericOperator | null;
  lastSeen?: DateOperator | null;
  userVarString?: CustomFieldStringOperator | null;
  userVarFloat?: CustomFieldFloatOperator | null;
  userVarInt?: CustomFieldIntOperator | null;
  userVarBool?: CustomFieldBoolOperator | null;
  userVarDate?: CustomFieldDateOperator | null;
  userVarStrings?: CustomFieldStringsOperator | null;
  userVarFloats?: CustomFieldFloatsOperator | null;
  userVarInts?: CustomFieldIntsOperator | null;
  userVarDates?: CustomFieldDatesOperator | null;
  userVarBools?: CustomFieldBoolsOperator | null;
  userSet?: UserSetOperator | null;
}

export namespace UserFilter {
  export enum filter {
    email = 1,
    name = 2,
    signedUp = 3,
    userId = 4,
    totalActiveTime = 5,
    totalTime = 6,
    averageSessionActiveTime = 7,
    averageSessionLength = 8,
    firstSeen = 9,
    totalSessions = 10,
    lastSeen = 11,
    userVarString = 12,
    userVarFloat = 13,
    userVarInt = 14,
    userVarBool = 15,
    userVarDate = 16,
    userVarStrings = 17,
    userVarFloats = 18,
    userVarInts = 19,
    userVarDates = 20,
    userVarBools = 21,
    userSet = 22
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum filter_keys {
    email = 'email',
    name = 'name',
    signedUp = 'signedUp',
    userId = 'userId',
    totalActiveTime = 'totalActiveTime',
    totalTime = 'totalTime',
    averageSessionActiveTime = 'averageSessionActiveTime',
    averageSessionLength = 'averageSessionLength',
    firstSeen = 'firstSeen',
    totalSessions = 'totalSessions',
    lastSeen = 'lastSeen',
    userVarString = 'userVarString',
    userVarFloat = 'userVarFloat',
    userVarInt = 'userVarInt',
    userVarBool = 'userVarBool',
    userVarDate = 'userVarDate',
    userVarStrings = 'userVarStrings',
    userVarFloats = 'userVarFloats',
    userVarInts = 'userVarInts',
    userVarDates = 'userVarDates',
    userVarBools = 'userVarBools',
    userSet = 'userSet'
  }

  export function filter_oneof(m: UserFilter): { opt: filter.averageSessionActiveTime, key: filter_keys.averageSessionActiveTime, val: DurationOperator } | { opt: filter.averageSessionLength, key: filter_keys.averageSessionLength, val: DurationOperator } | { opt: filter.email, key: filter_keys.email, val: StringOperator } | { opt: filter.firstSeen, key: filter_keys.firstSeen, val: DateOperator } | { opt: filter.lastSeen, key: filter_keys.lastSeen, val: DateOperator } | { opt: filter.name, key: filter_keys.name, val: StringOperator } | { opt: filter.signedUp, key: filter_keys.signedUp, val: SignedUpOperator } | { opt: filter.totalActiveTime, key: filter_keys.totalActiveTime, val: DurationOperator } | { opt: filter.totalSessions, key: filter_keys.totalSessions, val: NumericOperator } | { opt: filter.totalTime, key: filter_keys.totalTime, val: DurationOperator } | { opt: filter.userId, key: filter_keys.userId, val: StringOperator } | { opt: filter.userSet, key: filter_keys.userSet, val: UserSetOperator } | { opt: filter.userVarBool, key: filter_keys.userVarBool, val: CustomFieldBoolOperator } | { opt: filter.userVarBools, key: filter_keys.userVarBools, val: CustomFieldBoolsOperator } | { opt: filter.userVarDate, key: filter_keys.userVarDate, val: CustomFieldDateOperator } | { opt: filter.userVarDates, key: filter_keys.userVarDates, val: CustomFieldDatesOperator } | { opt: filter.userVarFloat, key: filter_keys.userVarFloat, val: CustomFieldFloatOperator } | { opt: filter.userVarFloats, key: filter_keys.userVarFloats, val: CustomFieldFloatsOperator } | { opt: filter.userVarInt, key: filter_keys.userVarInt, val: CustomFieldIntOperator } | { opt: filter.userVarInts, key: filter_keys.userVarInts, val: CustomFieldIntsOperator } | { opt: filter.userVarString, key: filter_keys.userVarString, val: CustomFieldStringOperator } | { opt: filter.userVarStrings, key: filter_keys.userVarStrings, val: CustomFieldStringsOperator } | null {
    if (m.email != null) { return { opt: filter.email, key: filter_keys.email, val: m.email } }
    if (m.name != null) { return { opt: filter.name, key: filter_keys.name, val: m.name } }
    if (m.signedUp != null) { return { opt: filter.signedUp, key: filter_keys.signedUp, val: m.signedUp } }
    if (m.userId != null) { return { opt: filter.userId, key: filter_keys.userId, val: m.userId } }
    if (m.totalActiveTime != null) { return { opt: filter.totalActiveTime, key: filter_keys.totalActiveTime, val: m.totalActiveTime } }
    if (m.totalTime != null) { return { opt: filter.totalTime, key: filter_keys.totalTime, val: m.totalTime } }
    if (m.averageSessionActiveTime != null) { return { opt: filter.averageSessionActiveTime, key: filter_keys.averageSessionActiveTime, val: m.averageSessionActiveTime } }
    if (m.averageSessionLength != null) { return { opt: filter.averageSessionLength, key: filter_keys.averageSessionLength, val: m.averageSessionLength } }
    if (m.firstSeen != null) { return { opt: filter.firstSeen, key: filter_keys.firstSeen, val: m.firstSeen } }
    if (m.totalSessions != null) { return { opt: filter.totalSessions, key: filter_keys.totalSessions, val: m.totalSessions } }
    if (m.lastSeen != null) { return { opt: filter.lastSeen, key: filter_keys.lastSeen, val: m.lastSeen } }
    if (m.userVarString != null) { return { opt: filter.userVarString, key: filter_keys.userVarString, val: m.userVarString } }
    if (m.userVarFloat != null) { return { opt: filter.userVarFloat, key: filter_keys.userVarFloat, val: m.userVarFloat } }
    if (m.userVarInt != null) { return { opt: filter.userVarInt, key: filter_keys.userVarInt, val: m.userVarInt } }
    if (m.userVarBool != null) { return { opt: filter.userVarBool, key: filter_keys.userVarBool, val: m.userVarBool } }
    if (m.userVarDate != null) { return { opt: filter.userVarDate, key: filter_keys.userVarDate, val: m.userVarDate } }
    if (m.userVarStrings != null) { return { opt: filter.userVarStrings, key: filter_keys.userVarStrings, val: m.userVarStrings } }
    if (m.userVarFloats != null) { return { opt: filter.userVarFloats, key: filter_keys.userVarFloats, val: m.userVarFloats } }
    if (m.userVarInts != null) { return { opt: filter.userVarInts, key: filter_keys.userVarInts, val: m.userVarInts } }
    if (m.userVarDates != null) { return { opt: filter.userVarDates, key: filter_keys.userVarDates, val: m.userVarDates } }
    if (m.userVarBools != null) { return { opt: filter.userVarBools, key: filter_keys.userVarBools, val: m.userVarBools } }
    if (m.userSet != null) { return { opt: filter.userSet, key: filter_keys.userSet, val: m.userSet } }
    return null;
  }
}

export interface UserSetOperator {
  union?: UserSetValue | null;
  intersection?: UserSetValue | null;
}

export namespace UserSetOperator {
  export enum operator {
    union = 1,
    intersection = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    union = 'union',
    intersection = 'intersection'
  }

  export function operator_oneof(m: UserSetOperator): { opt: operator.intersection, key: operator_keys.intersection, val: UserSetValue } | { opt: operator.union, key: operator_keys.union, val: UserSetValue } | null {
    if (m.union != null) { return { opt: operator.union, key: operator_keys.union, val: m.union } }
    if (m.intersection != null) { return { opt: operator.intersection, key: operator_keys.intersection, val: m.intersection } }
    return null;
  }
}

export interface UserSetValue {
  userProperties: UserProperty[];
}
